import { render } from "./EducationAndExperience.vue?vue&type=template&id=bf3f5ff2&scoped=true"
import script from "./EducationAndExperience.vue?vue&type=script&lang=js"
export * from "./EducationAndExperience.vue?vue&type=script&lang=js"

import "./EducationAndExperience.vue?vue&type=style&index=0&id=bf3f5ff2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf3f5ff2"]])

export default __exports__